import React, { useState } from 'react'
import { useTranslation } from 'i18n'
import ReceiptViewHeader from './ReceiptViewHeader'
import ReceiptDropzoneButton from './ReceiptDropzoneButton'
import UploadByCamera from 'components/UploadByCamera'

const UploadView = ({
  canContinue,
  headline,
  introCopy,
  onUploadNext,
  handleImageUpload,
  setUploadErrors,
  uploadInProgress,
  children,
  handleUploadError,
  handleUpload,
  sizeError,
  typeError,
  amountError,
}) => {
  const { t } = useTranslation(['receipt', 'common'])
  return (
    <div className="receipt-view upload-view">
      <ReceiptViewHeader headline={headline} introCopy={introCopy} />
      <div className={`receipt-view-content`}>
        {children}
        {canContinue === false && (
          <p className="error">{t('receipt:error.needAtLeastOneImage')}</p>
        )}
      </div>
      <div>
        {(sizeError || typeError || amountError) && (
          <p className="error">{t('receipt:error.someImagesFailed')}</p>
        )}
        {sizeError && (
          <p className="error">{t('receipt:error.imageTooLarge')}</p>
        )}
        {typeError && (
          <p className="error">{t('receipt:error.unsupportedImageType')}</p>
        )}
        {amountError && (
          <p className="error">{t('receipt:error.tooManyImages')}</p>
        )}
      </div>
      <div className={`receipt-button-container`}>
        <ReceiptDropzoneButton
          setUploadErrors={setUploadErrors}
          onUpload={files => {
            handleImageUpload(files)
            handleUpload()
          }}
          onError={handleUploadError}
          className="btn themed-button-secondary"
          label={t('receipt:uploadMoreImages')}
          disabled={uploadInProgress}
        />
        <UploadByCamera
          onUpload={files => {
            handleImageUpload(files)
            handleUpload()
          }}
          onError={handleUploadError}
          className="receipt-upload-button"
          buttonClassName="btn themed-button-secondary"
          disabled={uploadInProgress}
        />
        <button
          className="btn themed-button"
          onClick={() => {
            onUploadNext && onUploadNext()
          }}
          disabled={uploadInProgress || canContinue !== true}
        >
          {t('common:next')}
        </button>
      </div>
    </div>
  )
}
export default UploadView
